import { moduleNames } from "@lib/appconst"
import { CustomerTypeEnum } from "@lib/enum"
import fileService from "@services/common/fileService"
import customerPotentialService from "@services/customer/customerPotentialService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import { action, makeAutoObservable, observable } from "mobx"

class CustomerPotentialStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable tableECIData!: any

  @observable detailData!: any
  @observable auditLogData!: any

  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }
    this.tableECIData = []
    this.auditLogData = []
  }

  @action
  async createOrUpdate(body: any, files?: any) {
    if (!body.id) {
      this.isLoading = true
      const result = await customerPotentialService.create(body).catch(() => {
        this.isLoading = false
      })

      const { uniqueId } = result
      if (files && files.length && uniqueId) {
        files.forEach(async (file) => {
          if (file.originFileObj !== undefined) {
            const fileUpload = file.originFileObj
            await fileService
              .upload(moduleNames.customerAvatar, uniqueId, fileUpload)
              .catch(() => {
                this.isLoading = false
              })
          }
        })
      }
      this.isLoading = false
    } else {
      this.isLoading = true
      const result = await customerPotentialService.update(body).catch(() => {
        this.isLoading = false
      })

      const { uniqueId } = result
      if (files && files.length && uniqueId) {
        files.forEach(async (file) => {
          if (file.originFileObj !== undefined) {
            const fileUpload = file.originFileObj
            await fileService
              .upload(moduleNames.customerAvatar, uniqueId, fileUpload)
              .catch(() => {
                this.isLoading = false
              })
          }
        })
      }
      this.isLoading = false
    }
  }

  @action
  async initDetailData() {
    this.detailData = {
      id: undefined,
      customerType: CustomerTypeEnum.INDIVIDUAL,
    }
  }

  @action
  async activateOrDeactivate(id: number, isActive) {
    await customerPotentialService.activateOrDeactivate(id, isActive)
  }
  @action
  async bulkActive(id: number[]) {
    await customerPotentialService.bulkActive(id)
  }
  @action
  async get(id: any, isViewFull: boolean = true) {
    this.isLoading = true
    const result = await customerPotentialService
      .get(id, isViewFull)
      .finally(() => {
        this.isLoading = false
      })
    this.detailData = result
    return result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await customerPotentialService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async checkExist(params: any) {
    this.isLoading = true
    const result = await customerPotentialService
      .checkExist(params)
      .finally(() => (this.isLoading = false))
    return result
  }
  @action
  async getECI(params: any) {
    this.isLoading = true
    const result = await customerPotentialService
      .getECI(params)
      .finally(() => (this.isLoading = false))
    this.tableECIData = result
  }
  @action
  async updateSpecialCare(body: any) {
    this.isLoading = true
    const result = await customerPotentialService
      .updateSpecialCare(body)
      .finally(() => {
        this.isLoading = false
        this.detailData = { ...this.detailData, ...body }
      })

    return result
  }

  @action
  async updateStatus(body: any) {
    this.isLoading = true
    const result = await customerPotentialService
      .updateStatus(body)
      .finally(() => {
        this.isLoading = false
        this.detailData = { ...this.detailData, status: body.status }
        this.tableData.items = this.tableData.items?.map((x) => {
          if (x.id === body.id) x.status = body.status
          return x
        })
      })

    return result
  }
  @action
  async getAuditLog(id: any) {
    const result = await customerPotentialService.getAuditLog(id)

    this.auditLogData = result
  }
}

export default CustomerPotentialStore
